import { Box } from "@mui/material";

import ExtensaoBanner from "./extensaoBanner";
import ListaUploads from "./listaUploads";
import UploadArquivos from "./uploadArquivos";

export default function AbaUploads() {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <ExtensaoBanner />
      <UploadArquivos />
      <ListaUploads />
    </Box>
  );
}
